<script setup>
import AutocompleteFilter from '@/components/widgets/AutocompleteFilter.vue';
import { inject, onMounted, ref } from 'vue';
import { useInfinite } from '@/composables/use-infinity';

const backendApi = inject('backendApi');

const emit = defineEmits(['update', 'update:focused']);

const selected = ref(null);

const fetchWhatsappContentTemplates = ({ pattern, page, limit }) =>
    backendApi().whatsappContentTemplates().index({
        pattern,
        page,
        limit,
        active: true
    });

const {
    items: whatsappContentTemplates,
    loading: isLoading,
    showRetryButton,
    hasMore,
    searchQuery,
    getItems,
    loadMore,
    reset
} = useInfinite(fetchWhatsappContentTemplates);

const handleSearch = () => {
    reset();
    getItems();
};

// Initial data fetch on mount
onMounted(() => {
    getItems();
});
</script>

<template>
    <AutocompleteFilter
        v-model="selected"
        v-model:search="searchQuery"
        :items="whatsappContentTemplates"
        item-title="name"
        item-value="id"
        :loading="isLoading"
        :show-retry-button="showRetryButton"
        :infinite-scroll="hasMore"
        @infinite-scroll="loadMore"
        @update="emit('update', selected)"
        @preparing-search="handleSearch"
        @search="handleSearch"
        @retry="handleSearch"
        @update:focused="(state) => emit('update:focused', state)"
    >
        <template v-slot:default="{ props, item }">
            <v-list-item
                v-bind="props"
                :title="`${item.raw.name ?? item.raw.action}`"
                :subtitle="`${item.raw.action ?? ''}`"
            >
            </v-list-item>
        </template>
    </AutocompleteFilter>
</template>
